import { Row, Col, GRID } from '../../components/custom';

import firstImage from '../../images/sample/CX/one.webp';
import secondImage from '../../images/sample/CX/two.webp';
import thirdImage from '../../images/sample/CX/three.webp';

export default function CX()
{
    return (
        <Col id='CX'>
            <Col className='banner'>
                <span className='title'>Visual Stories from Voice of Employees</span>
            </Col>
            <Col className='section' data-id='1'>
                <span className='title'>Customer Experience Segmentation</span>
                <span className='desc'>CX personas by clustering survey responses to identify distinct behavior or expectation profiles.</span>
                <Row className='container'>
                    <Col>
                        <img src={firstImage} alt='firstImage'/>
                        <GRID>
                            <span className='descsmall bold'>Cluster</span>
                            <span className='descsmall bold'>Cluster Size</span>
                            <span className='descsmall bold'>Ease of Use</span>
                            <span className='descsmall bold'>Support Quality</span>
                            <span className='descsmall bold'>Value for Money</span>
                            <span className='descsmall bold'>Feature Satisfaction</span>
                            <span className='descsmall'>0</span>
                            <span className='descsmall'>49</span>
                            <span className='descsmall'>6.05</span>
                            <span className='descsmall'>5.99</span>
                            <span className='descsmall'>6.14</span>
                            <span className='descsmall'>6.00</span>
                            <span className='descsmall'>1</span>
                            <span className='descsmall'>50</span>
                            <span className='descsmall'>2.99</span>
                            <span className='descsmall'>2.88</span>
                            <span className='descsmall'>2.93</span>
                            <span className='descsmall'>2.92</span>
                            <span className='descsmall'>2</span>
                            <span className='descsmall'>51</span>
                            <span className='descsmall'>7.90</span>
                            <span className='descsmall'>8.96</span>
                            <span className='descsmall'>7.86</span>
                            <span className='descsmall'>8.96</span>
                        </GRID>
                    </Col>
                    <Col>
                        <Col>
                            <span className='desc'>Cluster 0: <strong>"Cautious Optimizers"</strong></span>
                            <span className='descsmall'>Balanced but not thrilled — these customers see value but still seek better experience in usability and features. Target them with enhancements and proactive support.</span>
                        </Col>
                        <Col>
                            <span className='desc'>Cluster 1: <strong>"Disengaged Skeptics"</strong></span>
                            <span className='descsmall'>Frustrated and underserved — customers with low expectations and high dissatisfaction. Prioritize service recovery and conduct root-cause deep-dives.</span>
                        </Col>
                        <Col>
                            <span className='desc'>Cluster 2: <strong>"Loyal Advocates"</strong></span>
                            <span className='descsmall'>Highly satisfied — they value quality, service, and features. Keep them engaged through loyalty programs, early feature access, and testimonial opportunities.</span>
                        </Col>
                    </Col>
                </Row>
            </Col>
            <Col className='section' data-id='2'>
                <span className='title'>Severity of Customer Issues by Journey Stage</span>
                <span className='desc'>Identify and quantify the severity of customer issues across key journey stage</span>
                <Row className='container'>
                    <Col>
                        <Col>
                            <span className='desc'><strong>Billing shows the highest severity for:</strong></span>
                            <span className='descsmall'>Hidden Charges (9.0): Suggests pricing transparency concerns.</span>
                            <span className='descsmall'>Access Issues (7.2): Likely related to login or invoice retrieval problems.</span>
                        </Col>
                        <Col>
                            <span className='desc'><strong>App Experience is heavily impacted by:</strong></span>
                            <span className='descsmall'>Crashes (8.5) and Slowness (6.9): Impacts digital usability and reliability.</span>
                        </Col>
                        <Col>
                            <span className='desc'><strong>Onboarding faces moderate severity with:</strong></span>
                            <span className='descsmall'>Confusion (7.5) and Delays (6.8): Indicates issues in initial customer setup or orientation.</span>
                        </Col>
                    </Col>
                    <img src={secondImage} alt='secondImage'/>
                </Row>
            </Col>
            <Col className='section' data-id='3'>
                <span className='title'>Predicting Customer Churn Using Survey Responses</span>
                <span className='desc'>To predict which customers are most likely to churn or stay loyal </span>
                <Row className='container'>
                    <img src={thirdImage} alt='thirdImage'/>
                    <Col>
                        <Col>
                            <span className='desc'><strong>Modeling Techniques Applied</strong></span>
                            <span className='descsmall'><strong>Logistic Regression:</strong> Predicts churn probability based on weighted influence of survey factors.</span>
                            <span className='descsmall'><strong>Decision Tree Classifier:</strong> Maps logical if-then rules to classify customers into churn or non-churn groups.</span>
                        </Col>
                        <GRID>
                            <span className='descsmall bold'>Insight</span>
                            <span className='descsmall bold'>Recommended Action</span>
                            <span className='descsmall left'>Low satisfaction and support scores are strong churn indicators</span>
                            <span className='descsmall left'>Prioritize service training and ticket resolution speed</span>
                            <span className='descsmall left'>Ease of use and perceived value also contribute to churn risk</span>
                            <span className='descsmall left'>Improve UI/UX and communicate pricing value clearly</span>
                            <span className='descsmall left'>Explainable models can support frontline teams with churn watchlists</span>
                            <span className='descsmall left'>Build churn alerts and flag high-risk customers proactively</span>
                        </GRID>
                    </Col>
                </Row>
            </Col>
        </Col>
    )
}